import{LineHeight as l}from"./LineHeight.js";const e={Base:l.Base,Lg:l.Lg,Sm:l.Sm,Xl:l.Xl,Xxl:l.Xxl,"2xl":l.Xxl};export{e as IconSize};
